import { render, staticRenderFns } from "./DestaquesDestaques.vue?vue&type=template&id=092e1b1a&scoped=true&"
import script from "./DestaquesDestaques.vue?vue&type=script&lang=js&"
export * from "./DestaquesDestaques.vue?vue&type=script&lang=js&"
import style0 from "./DestaquesDestaques.vue?vue&type=style&index=0&id=092e1b1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "092e1b1a",
  null
  
)

export default component.exports